var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleManage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 513 513",
    height: 512,
    viewBox: "0 0 513 513",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m50.5 512c-11.046 0-20-8.954-20-20 0-100.355 81.645-182 182-182h30c22.033 0 43.578 3.899 64.038 11.591 10.339 3.887 15.57 15.419 11.684 25.758-3.887 10.341-15.419 15.572-25.759 11.684-15.944-5.994-32.755-9.033-49.963-9.033h-30c-78.299 0-142 63.701-142 142 0 11.046-8.954 20-20 20zm310-377c0-74.439-60.561-135-135-135s-135 60.561-135 135 60.561 135 135 135 135-60.561 135-135zm-40 0c0 52.383-42.617 95-95 95s-95-42.617-95-95 42.617-95 95-95 95 42.617 95 95zm162 317v-52.823c0-33.733-27.443-61.177-61.176-61.177h-52.824c-11.046 0-20 8.954-20 20s8.954 20 20 20h52.824c11.677 0 21.176 9.5 21.176 21.177v52.823c0 11.046 8.954 20 20 20s20-8.954 20-20zm-69.545-12.197c7.628-7.988 7.336-20.648-.652-28.276-7.989-7.628-20.648-7.336-28.277.651-36.912 38.653-88.734 60.822-142.181 60.822h-9.345c-11.046 0-20 8.954-20 20s8.954 20 20 20h9.345c64.321 0 126.688-26.68 171.11-73.197z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleManage);
export default __webpack_public_path__ + "static/media/role-manage.0d23f1f3a3aefdb6f26bd81dedba52f3.svg";
export { ForwardRef as ReactComponent };